document.addEventListener('DOMContentLoaded', function () {

  /* =========================
     BANNER SLIDER (OPTIMIZED)
  ========================== */
  document.querySelectorAll('.pro-slider').forEach(function (slider) {

    const track = slider.querySelector('.pro-slides');
    const slides = slider.querySelectorAll('.pro-slide');

    if (!track || slides.length <= 1) return;

    let index = 0;
    const speed = (slider.dataset.speed || 3) * 1000;

    let isSliding = false;

setInterval(() => {

  if(isSliding) return;

  isSliding = true;

  index++;

  if(index >= slides.length){
    index = 0;
  }

  track.style.transform =
    `translate3d(-${index * 100}%,0,0)`;

  setTimeout(()=>{
    isSliding = false;
  },500);

}, speed);

  });


  /* =========================
     PRODUCT AUTO SLIDER (OPTIMIZED GLOBAL LOOP)
  ========================== */
  const productSliders = document.querySelectorAll('.product-slider');

  productSliders.forEach(slider => {
    let index = 0;

    const cards = slider.querySelectorAll('li');
    if (!cards.length) return;

    const step = cards[0].offsetWidth + 18;

    setInterval(() => {

      const maxScroll = slider.scrollWidth - slider.clientWidth;

      index++;

      let scrollPos = index * step;

      if (scrollPos > maxScroll) {
        index = 0;
        scrollPos = 0;
      }

      slider.scrollTo({
        left: scrollPos,
        behavior: 'smooth'
      });

    }, 3500);

  });


  /* =========================
     TABS (LIGHTWEIGHT)
  ========================== */
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', function () {

      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));

      this.classList.add('active');
      document.getElementById(this.dataset.tab).classList.add('active');

    });
  });


  /* =========================
     UNIVERSAL VARIANT (LIGHT)
  ========================== */
  document.addEventListener("change", function (e) {

    if (!e.target.classList.contains("variant-select")) return;

    const select = e.target;
    const card = select.closest(".card");

    if (!card) return;

    const option = select.options[select.selectedIndex];

    const priceEl = card.querySelector(".current-price");
    const btn = card.querySelector(".add-to-cart");

    if (btn) btn.dataset.id = option.value;
    if (priceEl && option.dataset.price) {
      priceEl.innerText = option.dataset.price;
    }

  });


  /* =========================
     UNIVERSAL ADD TO CART (LIGHT)
  ========================== */
  document.addEventListener("click", function (e) {

    if (!e.target.classList.contains("add-to-cart") &&
        !e.target.classList.contains("story-add-cart")) return;

    e.preventDefault();

    const btn = e.target;
    const id = btn.dataset.id;

    if (!id) return;

    btn.innerText = "ADDING...";
    btn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {

  btn.innerText = "ADDED ✓";

  setTimeout(async () => {

    const drawer = document.querySelector("cart-drawer");

    if (drawer) {

      try {
        const sectionResponse = await fetch(
          "/cart?sections=cart-drawer,cart-icon-bubble"
        );

        const sections = await sectionResponse.json();

        if (typeof drawer.renderContents === "function") {
          drawer.renderContents({
            id: id,
            sections: sections
          });
        } else {
          drawer.open(btn);
        }

      } catch (error) {
        console.error("Cart drawer refresh error:", error);
        drawer.open(btn);
      }

    }

    btn.innerText = "ADD TO CART";
    btn.disabled = false;

  }, 150);

})
    .catch(() => {
      btn.innerText = "ERROR";
      btn.disabled = false;
    });

  });

});